import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
function EnglishContent() {
  return <>
      <h1 className="text-3xl md:text-5xl font-bold mb-8 text-[#2A4B7C]" data-id="element-130" data-mp="1toi633m8f7lv">
        Submit Your Work
      </h1>

      <p className="text-lg mb-2 font-semibold text-[#2A4B7C]" data-id="element-131" data-mp="1yl8nbu9rw98v">
        Guidelines - English
      </p>
      <p className="text-sm mb-8 text-[#334E68]" data-id="element-132" data-mp="23fuzw0rlc7uj">
        For Hebrew guidelines, check the Hebrew language version.
      </p>

      <div className="mb-8" data-id="element-133" data-mp="2ceghntp8niu9">
        <p className="mb-2 text-[#2F3A45]" data-id="element-134" data-mp="2cdf2bd16wa6q">
          In order to submit your work, email the following address:
        </p>
        <a href="mailto:submissions.stjournal@gmail.com" className="text-lg md:text-xl hover:text-amber-600 transition-colors font-semibold break-all text-[#2A4B7C]" data-id="element-135" data-mp="2heku98n0ztf7">
          submissions.stjournal@gmail.com
        </a>
      </div>

      <div className="mb-8" data-id="element-136" data-mp="ry3fi4auudez">
        <p className="mb-2 text-[#334E68]" data-id="element-137" data-mp="rz50b0hoae9w">The title of the email should be:</p>
        <p className="font-semibold mb-2 text-[#2A4B7C]" data-id="element-138" data-mp="2d23kyab9kvwn">
          Category + First Name + Surname.
        </p>
        <p className="italic mb-4 text-[#2F3A45]" data-id="element-139" data-mp="2890q7yur3gev">
          Example: Flash Fiction + Mark + Johnson
        </p>
        <p className="mb-2 text-[#2A4B7C]" data-id="element-140" data-mp="23bs7nx5oxad3">
          Please submit in the email of your language. For example, if you wrote
          a piece in Hebrew, make sure the title of the email is in Hebrew.
        </p>
        <p className="text-[#2F3A45]" data-id="element-141" data-mp="2vxtpa46o64dp">
          The piece should be in a <strong data-id="element-142" data-mp="2r2e935l6vwe4">PDF</strong> or <strong data-id="element-143" data-mp="2qz08o2w35x9b">DOCX</strong>{' '}
          file.
        </p>
      </div>

      <div className="border-t border-gray-200 pt-8" data-id="element-144" data-mp="2m0p2q38ww6wd">
        <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-145" data-mp="2i0ok06es59ji">
          List of Categories
        </h2>

        {/* Fiction */}
        <div className="mb-8" data-id="element-146" data-mp="1anmj0zbin17z">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-147" data-mp="1akqlvd7hsgkl">Fiction</h3>
          <ul className="space-y-2 pl-6" data-id="element-148" data-mp="16jokoqu0lufz">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-149" data-mp="182f0weala85h">
              <span className="text-amber-600 font-bold mt-1" data-id="element-150" data-mp="1836l6syqkjgg">•</span>
              <span className="text-[#2F3A45]" data-id="element-151" data-mp="1d0gisvwa41fd">
                <strong className="text-[#374151]" data-id="element-152" data-mp="1cz5fex6qwvos">Micro Fiction</strong> -
                Under 350 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-153" data-mp="132alkrlf3jgu">
              <span className="text-amber-600 font-bold mt-1" data-id="element-154" data-mp="pc74sg5b4hys">•</span>
              <span className="text-[#2F3A45]" data-id="element-155" data-mp="p9ucpa5u4r80">
                <strong data-id="element-156" data-mp="u2vv3s5938wc">Flash Fiction</strong> - More than 350 words - Under
                1,000 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-157" data-mp="ffkjxrczdqwr">
              <span className="text-amber-600 font-bold mt-1" data-id="element-158" data-mp="kdvw48qr0di5">•</span>
              <span data-id="element-159" data-mp="6dbc5993kbn2">
                <strong data-id="element-160" data-mp="6ct7bo8dcp3j">Short Story</strong> - More than 1,000 words - Under
                3,000 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-161" data-mp="advb8id8dpbu">
              <span className="text-amber-600 font-bold mt-1" data-id="element-162" data-mp="3nwryqqgy8ul5">•</span>
              <span data-id="element-163" data-mp="3iwx90q8wub1o">
                <strong data-id="element-164" data-mp="3ixp5e3ac0ct0">Long Story</strong> - More than 3,000 words - Under
                10,000 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-165" data-mp="oy0j1obui5f">
              <span className="text-amber-600 font-bold mt-1" data-id="element-166" data-mp="3rwkblfddlmwb">•</span>
              <span data-id="element-167" data-mp="aoowl7sjd57m">
                <strong data-id="element-168" data-mp="ao6tbr7ghqq7">Really Long Story</strong> - More than 10,000 words.
              </span>
            </li>
          </ul>
        </div>

        {/* Non Fiction */}
        <div className="mb-8" data-id="element-169" data-mp="jhaeyms999vx">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-170" data-mp="jgh3x9m9jy7z">
            Non Fiction
          </h3>
          <ul className="space-y-2 pl-6" data-id="element-171" data-mp="fh887z7nxq9s">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-172" data-mp="fib2mh472aug">
              <span className="text-amber-600 font-bold mt-1" data-id="element-173" data-mp="tg7w34ncq14w">•</span>
              <span data-id="element-174" data-mp="ohemvof3kwaj">
                <strong data-id="element-175" data-mp="oi6gwut1qlyp">Short Essay</strong> - Under 500 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-176" data-mp="18i83fzmjhril">
              <span className="text-amber-600 font-bold mt-1" data-id="element-177" data-mp="1cjtdzeblptpm">•</span>
              <span data-id="element-178" data-mp="1hb1l23pgl2zm">
                <strong data-id="element-179" data-mp="1hajh0kwk1kh5">Essay</strong> - More than 500 words - Under 2,000
                words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-180" data-mp="1m8tej25r4x5x">
              <span className="text-amber-600 font-bold mt-1" data-id="element-181" data-mp="pkdkasrp5zmh">•</span>
              <span data-id="element-182" data-mp="pm88qh26g9vb">
                <strong data-id="element-183" data-mp="tl7cvzg342lp">Long Essay</strong> - More than 2,000 words - Under
                5,000 words.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-184" data-mp="yiz04g5sb0jk">
              <span className="text-amber-600 font-bold mt-1" data-id="element-185" data-mp="13k6bep74yhuz">•</span>
              <span data-id="element-186" data-mp="13hadh0vaft6j">
                <strong data-id="element-187" data-mp="2a08hmx5crii8">Memoir</strong> - Under 3,000 words.
              </span>
            </li>
          </ul>
        </div>

        {/* Poetry */}
        <div className="mb-8" data-id="element-188" data-mp="2ewyxbjd8wc34">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-189" data-mp="3bgkwuggmop0">Poetry</h3>
          <ul className="space-y-2 pl-6" data-id="element-190" data-mp="3dj8l7u545qk">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-191" data-mp="3uh804ysp8gx1">
              <span className="text-amber-600 font-bold mt-1" data-id="element-192" data-mp="3uk3wwjst8zjw">•</span>
              <span data-id="element-193" data-mp="3ppghrbjp5hhz">
                <strong data-id="element-194" data-mp="3poyehuyma30k">Poetry</strong> - Unlimited, send each poem in a
                separate docx/pdf file.
              </span>
            </li>
          </ul>
        </div>

        {/* Other */}
        <div className="mb-8" data-id="element-195" data-mp="3goa02z5ba0n5">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-196" data-mp="3bqqk9usytft3">Other</h3>
          <ul className="space-y-2 pl-6" data-id="element-197" data-mp="36s6wdout9ty3">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-198" data-mp="36t86nr406cer">
              <span className="text-amber-600 font-bold mt-1" data-id="element-199" data-mp="31tc2nrvb2kz7">•</span>
              <span data-id="element-200" data-mp="31v6r3g5scv81">
                <strong data-id="element-201" data-mp="150tqoxl0ri0z">Other written</strong> - Plays, Screenwriting and more…
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-202" data-mp="1017gkx0hmhwe">
              <span className="text-amber-600 font-bold mt-1" data-id="element-203" data-mp="zzwcew34r84r">•</span>
              <span data-id="element-204" data-mp="2ugcvx1us9w97">
                <strong data-id="element-205" data-mp="2ufurvj1vqdqq">Visual</strong> - Drawings, Paintings, Sketches, Videos…
              </span>
            </li>
          </ul>
        </div>
      </div>
    </>;
}
function HebrewContent() {
  return <>
      <h1 className="text-3xl md:text-5xl font-bold mb-8 text-[#2A4B7C]" data-id="element-206" data-mp="2khx6d3bemv1t">
        שלח את עבודתך
      </h1>

      <p className="text-lg mb-2 font-semibold text-[#2A4B7C]" data-id="element-207" data-mp="3d8feiiqzjmm3">
        הנחיות - עברית
      </p>
      <p className="text-sm text-gray-500 mb-8" data-id="element-208" data-mp="3i7i8n85fg8fa">
        ההנחיות באנגלית נמצאות בגרסה האנגלית.
      </p>

      <div className="mb-8" data-id="element-209" data-mp="3480sfh6763hj">
        <p className="text-gray-700 mb-2" data-id="element-210" data-mp="346peioj1ffcp">
          על מנת לשלוח לנו את היצירה שלכם, אנא שלחו את העבודה לכתובת מייל הבאה:
        </p>
        <a href="mailto:submissions.stjournal@gmail.com" className="text-lg md:text-xl hover:text-amber-600 transition-colors font-semibold break-all text-[#374151]" data-id="element-211" data-mp="387j4rojyd68r">
          submissions.stjournal@gmail.com
        </a>
      </div>

      <div className="mb-8" data-id="element-212" data-mp="1p9mt8050g9dt">
        <p className="text-gray-700 mb-2" data-id="element-213" data-mp="1p8tiyp6uf1qx">
          הכותרת של המייל צריכה להיות בפורמט הבא:
        </p>
        <p className="font-semibold mb-2 text-[#2A4B7C]" data-id="element-214" data-mp="1kbbf3d7oncps">
          קטגוריה + שם פרטי + שם משפחה.
        </p>
        <p className="text-gray-600 italic mb-4" data-id="element-215" data-mp="1z6hpsdhq3zpg">
          דוגמא: סיפור מהיר + איתן + לוי.
        </p>
        <p className="text-gray-700 mb-2" data-id="element-216" data-mp="1u7wpke2h1g10">
          הכותרת צריכה להיות בשפת היצירה. לדוגמא, אם היצירה שלכם כתובה באנגלית,
          עליכם לוודא שכותרת ההודעה באנגלית.
        </p>
        <p className="text-gray-700" data-id="element-217" data-mp="11mwrz10hkiu9">
          את היצירה יש לשלוח בקובץ <strong data-id="element-218" data-mp="1gb1decqxb8gq">PDF</strong> או <strong data-id="element-219" data-mp="1gbj4kuyqawhs">DOCX</strong>
          .
        </p>
      </div>

      <div className="border-t border-gray-200 pt-8" data-id="element-220" data-mp="1bizsk2fow9f3">
        <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-221" data-mp="1bh6nusomzz9q">
          רשימת קטגוריות
        </h2>

        {/* Fiction */}
        <div className="mb-8" data-id="element-222" data-mp="iv3zd7pbwzn2">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-223" data-mp="itsut5o27nuw">
            ספרות יפה
          </h3>
          <ul className="space-y-2 pr-6" data-id="element-224" data-mp="3ti8333s28phy">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-225" data-mp="2acfa46z9a3b">
              <span className="text-amber-600 font-bold mt-1" data-id="element-226" data-mp="2am61tzujla2">•</span>
              <span data-id="element-227" data-mp="78dvmhd0qvb3">
                <strong data-id="element-228" data-mp="77vt52zrjkuq">סיפורון (מיקרו)</strong> - מתחת ל-350 מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-229" data-mp="bcda6ueqnk1t">
              <span className="text-amber-600 font-bold mt-1" data-id="element-230" data-mp="gawtso5v0jr0">•</span>
              <span data-id="element-231" data-mp="l8yflguo6x66">
                <strong data-id="element-232" data-mp="l8gbjy1rnenp">סיפור מהיר</strong> - מעל 350 מילים - מתחת ל-1,000
                מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-233" data-mp="q0ggk4wp0xr5">
              <span className="text-amber-600 font-bold mt-1" data-id="element-234" data-mp="uzazd6unumb9">•</span>
              <span data-id="element-235" data-mp="z0msvngnnroq">
                <strong data-id="element-236" data-mp="z14t0v6fuq1x">סיפור קצר</strong> - מעל 1,000 מילים - מתחת ל-3,000
                מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-237" data-mp="140927ltd4ns9">
              <span className="text-amber-600 font-bold mt-1" data-id="element-238" data-mp="2oi0eqtunrbv8">•</span>
              <span data-id="element-239" data-mp="2jingze290kdv">
                <strong data-id="element-240" data-mp="2ji5nuqavuma6">סיפור ארוך</strong> - מעל 3,000 מילים - מתחת ל-10,000
                מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-241" data-mp="2fhlr3nu81kok">
              <span className="text-amber-600 font-bold mt-1" data-id="element-242" data-mp="2aiqyxvad6jrs">•</span>
              <span data-id="element-243" data-mp="3788d6ynexe53">
                <strong data-id="element-244" data-mp="378rinfvvma28">סיפור ממש ארוך</strong> - מעל 10,000 מילים.
              </span>
            </li>
          </ul>
        </div>

        {/* Non Fiction */}
        <div className="mb-8" data-id="element-245" data-mp="338r660sc88xt">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-246" data-mp="2yfo7xfcm8bba">
            ספרות עיון
          </h3>
          <ul className="space-y-2 pr-6" data-id="element-247" data-mp="2thd1zfpfykyc">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-248" data-mp="2tgl4fzcaad5f">
              <span className="text-amber-600 font-bold mt-1" data-id="element-249" data-mp="3qwh83ggcby8a">•</span>
              <span data-id="element-250" data-mp="3m5ijzup41vuh">
                <strong data-id="element-251" data-mp="3m58ue87z9qpb">חיבור קצר</strong> - פחות מ-500 מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-252" data-mp="1f9au4en4gfab">
              <span className="text-amber-600 font-bold mt-1" data-id="element-253" data-mp="1fbxa92o2w345">•</span>
              <span data-id="element-254" data-mp="1acu6dlju42xr">
                <strong data-id="element-255" data-mp="1adcaf4cqnlg8">חיבור</strong> - יותר מ-500 מילים - פחות מ-2,000 מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-256" data-mp="1k9720oyxwqv5">
              <span className="text-amber-600 font-bold mt-1" data-id="element-257" data-mp="1k7vvihe4150c">•</span>
              <span data-id="element-258" data-mp="1y7wyq3hukoiz">
                <strong data-id="element-259" data-mp="1y73xtj5kkt8r">חיבור ארוך</strong> - יותר מ-2,000 מילים - פחות מ-5,000
                מילים.
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-260" data-mp="27yi3k8o46pac">
              <span className="text-amber-600 font-bold mt-1" data-id="element-261" data-mp="27xynkxi0yayy">•</span>
              <span data-id="element-262" data-mp="230q3ush89yvl">
                <strong data-id="element-263" data-mp="230gkhnqoupyv">זיכרונות</strong> - פחות מ-3,000 מילים.
              </span>
            </li>
          </ul>
        </div>

        {/* Poetry */}
        <div className="mb-8" data-id="element-264" data-mp="2c0v84tr4kh5j">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-265" data-mp="2c1o4d0sgjo9f">שירה</h3>
          <ul className="space-y-2 pr-6" data-id="element-266" data-mp="2vlvhh6bo94u5">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-267" data-mp="2vmy8rfcwp9al">
              <span className="text-amber-600 font-bold mt-1" data-id="element-268" data-mp="30k6qjeu57bbb">•</span>
              <span data-id="element-269" data-mp="2mlqhhh8t58q0">
                <strong data-id="element-270" data-mp="2mkf4cqth2om8">שירה</strong> - אין מגבלה, לשלוח כל שיר בקובץ PDF/DOCX
                נפרד.
              </span>
            </li>
          </ul>
        </div>

        {/* Other */}
        <div className="mb-8" data-id="element-271" data-mp="2cv5bv9upv3xl">
          <h3 className="text-xl font-semibold mb-3 text-[#2A4B7C]" data-id="element-272" data-mp="2cu2mj6d1l9js">אחר</h3>
          <ul className="space-y-2 pr-6" data-id="element-273" data-mp="2hmnbnul06ygz">
            <li className="text-gray-700 flex items-start gap-3" data-id="element-274" data-mp="2hogltjuts0tq">
              <span className="text-amber-600 font-bold mt-1" data-id="element-275" data-mp="22yiw2zh8z32f">•</span>
              <span data-id="element-276" data-mp="27w148nnfxe9d">
                <strong data-id="element-277" data-mp="27xlzkfhkx18a">כתיבה אחרת</strong> - הכל כולל מחזות, תסריטים, ועוד…
              </span>
            </li>
            <li className="text-gray-700 flex items-start gap-3" data-id="element-278" data-mp="1ty44jidowrqh">
              <span className="text-amber-600 font-bold mt-1" data-id="element-279" data-mp="1ywdzpszezsc3">•</span>
              <span data-id="element-280" data-mp="1yxp3hssv1037">
                <strong data-id="element-281" data-mp="4fe26hl8ezyw">חזותי</strong> - ציורים, איורים, סרטונים ועוד…
              </span>
            </li>
          </ul>
        </div>
      </div>
    </>;
}
export function SubmitPage() {
  const {
    language
  } = useLanguage();
  return <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-282" data-mp="3qw1snji9ekgq">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white rounded-lg shadow-md p-6 md:p-12" data-id="element-283" data-mp="3mu6qydwf252f">
        {language === 'en' ? <EnglishContent data-id="element-284" data-mp="ig89sy0ggwwi" /> : <HebrewContent data-id="element-285" data-mp="idm473x4krgx" />}
      </motion.div>
    </div>;
}